import createIcon from '../../createIcon';

/**
 * @component @name FontDownload
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS45MyAxMy41SDE0LjA3TDEyIDcuOThMOS45MyAxMy41Wk0yMCAySDRDMi45IDIgMiAyLjkgMiA0VjIwQzIgMjEuMSAyLjkgMjIgNCAyMkgyMEMyMS4xIDIyIDIyIDIxLjEgMjIgMjBWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTE1Ljk1IDE4LjVMMTQuODEgMTUuNUg5LjE3TDguMDUgMTguNUg1Ljk2TDExLjA3IDUuNUgxMi45M0wxOC4wNCAxOC41SDE1Ljk1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FontDownload = createIcon('FontDownload', [
  [
    'path',
    {
      d: 'M9.93 13.5H14.07L12 7.98L9.93 13.5ZM20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM15.95 18.5L14.81 15.5H9.17L8.05 18.5H5.96L11.07 5.5H12.93L18.04 18.5H15.95Z',
      key: '1wptgp',
    },
  ],
]);

export default FontDownload;
